import { Component, OnInit } from '@angular/core';

// Deprecated
@Component({
  selector: 'app-product-select',
  templateUrl: './product-select.component.html',
  styleUrls: ['./product-select.component.css']
})
export class ProductSelectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/product-select/product-select.component.ts